import React from 'react'

function AboutArea() {
  return (
    <div id="about-us" className="section-area access-background">
        <div className="container txtsize2">
            
            <h4>Anton and Nick. We’re the father and son behind Scrilla</h4> 
            <p>
                A cashback app born from five generations of pharmacy know-how and a shared family mission to make healthcare more affordable. With deep roots in the pharmaceutical industry, we’ve seen firsthand how essential medications can put pressure on everyday budgets. 
            </p>
            <p >
                <strong>So we asked ourselves</strong>: <span className="italic">What if we could give something back?</span>
            </p>
            <p>
                That simple idea became <strong>Scrilla</strong>. Built on decades of industry insight and a whole lot of heart, our app helps you earn cashback on the health products you need most.
            </p>
            <p>
                Scrilla — let us fetch your cash backs.
            </p>

            <p>
                Because when family looks after family, everybody wins.
            </p>

        </div>
    </div>
  )
}

export default AboutArea